"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function MacMultitoneGreyFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__mac-multitone-grey-filled__clip0_13467_153)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M9.764 15.263c-.728-2.368-.8-6.008-.8-6.008H6.408a28.479 28.479 0 011.6-8.53l6.744-.04a.862.862 0 01.606.256.84.84 0 01.242.605V14.43a.84.84 0 01-.244.606.861.861 0 01-.608.255l-4.984-.028z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M9.668 15.105c-.716-2.309-.8-5.885-.8-5.885H6.356A27.563 27.563 0 017.936.895h-6.64C.836.895 0 1.617 0 2.079V13.92c0 .462.84 1.184 1.296 1.184h8.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M9.668 15.303a.2.2 0 01-.192-.143c-.608-2.036-.744-4.953-.768-5.735H6.48c-.11 0-.2-.088-.2-.197A29.15 29.15 0 017.812.82a.202.202 0 01.34-.068.196.196 0 01.04.194 29.145 29.145 0 00-1.508 8.08H8.9c.109 0 .198.086.2.194 0 .035.084 3.552.76 5.826a.195.195 0 01-.017.15.2.2 0 01-.119.095l-.056.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M1.6.5h12.8c.884 0 1.6.707 1.6 1.579v11.842a1.59 1.59 0 01-1.6 1.579H1.6A1.59 1.59 0 010 13.921V2.08A1.59 1.59 0 011.6.5zm14 1.579c0-.654-.537-1.184-1.2-1.184H1.6c-.663 0-1.2.53-1.2 1.184v11.842c0 .654.537 1.184 1.2 1.184h12.8c.663 0 1.2-.53 1.2-1.184V2.08z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.104 12.022a8.319 8.319 0 01-5.148-1.855.195.195 0 01-.013-.264.202.202 0 01.265-.04c2.484 2.013 6.5 2.665 9.368 0a.202.202 0 01.342.095.196.196 0 01-.07.193 6.873 6.873 0 01-4.744 1.871zM11.65 5.829c-.138 0-.25-.088-.25-.197v-.79c0-.109.112-.197.25-.197s.25.088.25.197v.79c0 .109-.112.197-.25.197zM4.45 5.829c-.138 0-.25-.088-.25-.197v-.79c0-.109.112-.197.25-.197s.25.088.25.197v.79c0 .109-.112.197-.25.197z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__mac-multitone-grey-filled__clip0_13467_153"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

MacMultitoneGreyFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
MacMultitoneGreyFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = MacMultitoneGreyFilled;
exports["default"] = _default;